module.exports = __webpack_public_path__ + "static/fonts/382A4A_1_0.9a1170b.woff";